import { isOfType } from "../../../../utils";

export interface INominalIntegerValue {
  type: "nominal_integer";
  nominal: number;
}

export interface IUniformIntegerValue {
  type: "uniform_integer";
  lower_bound: number;
  upper_bound: number;
}

export type IIntegerValue = INominalIntegerValue | IUniformIntegerValue;

export const isNominalIntegerValue =
  isOfType<INominalIntegerValue>("nominal_integer");
const isUniformIntegerValue = isOfType<IUniformIntegerValue>("uniform_integer");

export const integerValueToString = (integerValue: IIntegerValue): string => {
  if (isUniformIntegerValue(integerValue)) {
    return `[${integerValue.lower_bound}, ${integerValue.upper_bound}]`;
  }
  if (isNominalIntegerValue(integerValue)) {
    return `${integerValue.nominal}`;
  }
  return "";
};
